import { routes } from '../../router';

export const sideBarItems = routes
  .filter((item) => item.sidebarPosition !== undefined)
  .sort((a, b) => (a.sidebarPosition && b.sidebarPosition ? a.sidebarPosition - b.sidebarPosition : 0));
